import { Button, Col, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { TableColumns } from "../../../../shared/components/ui/Table/types";
import { productWarehousesService } from "../../../../shared/services";
import { ProductWarehouses } from "../../../../redux/@types";
import Table from "../../../../shared/components/ui/Table";
import { useParams } from "react-router-dom";
import { useDeleteProductWarehouse } from "../../hooks/productWerehouses";

const { Title } = Typography;

export const TableWarehouseSauces = () => {
  const {showDeleteConfirm, setTableProps} = useDeleteProductWarehouse()
  const {warehouse_id} = useParams()
  const columns: TableColumns<ProductWarehouses> = [
    {
      title: "ID",
      width: 1,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Bodega",
      width: 2,
      dataIndex: ['warehouse', 'name'],
      key: "id",
      filterType: "text",
    },
    {
      title: "Estado",
      width: 3,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                  padding:"6px 20px", 
                  borderRadius: 36,
                  backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
                }}
                level={5}
              >
                {item.status}
              </Title>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Producto",
      width: 2,
      dataIndex: ['product', 'name'],
      key: "id",
      filterType: "text",
    },
    {
      title: "Cantidad",
      width: 2,
      dataIndex: ['product', 'quantity'],
      key: "id",
      filterType: "text",
    },
    {
      title: "Precio",
      width: 2,
      dataIndex: ['product', 'price'],
      key: "id",
      filterType: "text",
    },
    {
      title: "Codigo",
      width: 2,
      dataIndex: ['product', 'code'],
      key: "id",
      filterType: "text",
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 4,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              danger
              onClick={() => showDeleteConfirm(item.id, `${item.warehouse.name}`)}
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ]
  return (
    
    <Table<ProductWarehouses>
      columns={columns}
      scroll={{}}
      fetchQueryProps={{
        warehouse_id,
        $sort: { id: -1 },
      }}
      service={productWarehousesService}
      onLoad={setTableProps}
    />
  );
};
